// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;&#145;Be still, and know that I am God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I will be exalted among the nations;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I will be exalted in the earth.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;